type Param = 'xcxType' | 'type' | 'source' | 'id' | 'broadcastId' | 'bId' | 'instId' | 'orgId' | 'adminId' | 'promoterId' | 'referralId' | 'referralAppId' | 'code' | 'appId' | 'uid' | 'v' | 'vn' | 'token' | 'aid' | 'hot' | 'origin' | 'appid' | 'p' | 'urlType' | 'fxXcxopenId' | 'distributorId' | 'state' | 'enterType'|'creatorId'|'tabType';
/**
 * 获取地址上的字符串
 * @param query 要查询的地址上的参数
 */
export default function getUrlParam(query: Param): | string | undefined {
  const url = window.location.href;
  if (url.indexOf('?') !== -1) {
    const str = url.split('?');
    const len = str.length;
    for (let i = 0; i < len; i++) {
      const strItem = str[i];
      const strArray = strItem.split('&');
      const subLen = strArray.length;

      for (let i = 0; i < subLen; i++) {
        const itemArray = strArray[i].split('=');
        if (itemArray[0].toLocaleLowerCase() === query.toLocaleLowerCase()) {
          return itemArray[1];
        }
      }
    }
  }
  return undefined;
}